<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - Klassifizierung</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--classification">
            <form @submit.prevent="submit">

                <ask-for-quote-header :askForQuote="askForQuote"/>

                <div class="ask-for-quote--content">
                    <div class="container">
                        <div class="row">
                            <div class="col col-4">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Zeichnung</card-overline>
                                            </card-header>
                                            <card-content>
                                                <sketch-preview :sketchFile="currentSketchFile" />
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <form-actions v-if="!disabledTab">
                                            <form-button type="button" color="secondary" icon="button-arrow-right-circle" class="btn--block" @click="form.methods.zerspanen.drehen = !form.methods.zerspanen.drehen">Drehen</form-button>
                                            <form-button type="button" color="secondary" icon="button-arrow-right-circle" class="btn--block" @click="form.methods.zerspanen._3_achs_fraesen = !form.methods.zerspanen._3_achs_fraesen">Fräsen</form-button>
                                            <form-button type="button" color="secondary" icon="button-arrow-right-circle" class="btn--block" @click="form.methods.zerspanen.drehfraesen = !form.methods.zerspanen.drehfraesen">Drehfräsen</form-button>
                                        </form-actions>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Klassifizierung</card-overline>
                                            </card-header>
                                            <card-content>
                                                <div class="row" v-if="form.errors.methods || form.errors.materials">
                                                    <div class="col">
                                                        <div class="form-element form-element--error">
                                                            {{ form.errors.methods }}
                                                            {{ form.errors.materials }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col col-6">
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Zerspanen</p>
                                                            <template v-for="(value, name, index) in form.methods['zerspanen']">
                                                                <form-checkbox v-if="name !== 'zerspanen_andere_c' && name !== 'zerspanen_andere' " :key="index"
                                                                               v-model:checked="form.methods['zerspanen'][name]" :id="name"
                                                                               :option="labels.methodLabels['_zerspanen'][name]"/>
                                                            </template>
                                                        </div>
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Fügen</p>
                                                            <template v-for="(value, name, index) in form.methods['fuegen']">
                                                                <form-checkbox v-if="name !== 'fuegen_andere_c' && name !== 'fuegen_andere' " :key="index"
                                                                               v-model:checked="form.methods['fuegen'][name]" :id="name"
                                                                               :option="labels.methodLabels['_fuegen'][name]"/>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="col col-6">
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Trennen</p>
                                                            <template v-for="(value, name, index) in form.methods['trennen']">
                                                                <form-checkbox v-if="name !== 'trennen_andere_c' && name !== 'trennen_andere' " :key="index"
                                                                               v-model:checked="form.methods['trennen'][name]" :id="name"
                                                                               :option="labels.methodLabels['_trennen'][name]"/>
                                                            </template>
                                                        </div>
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Urformen</p>
                                                            <template v-for="(value, name, index) in form.methods['urformen']">
                                                                <form-checkbox v-if="name !== 'urformen_andere_c' && name !== 'urformen_andere' " :key="index"
                                                                               v-model:checked="form.methods['urformen'][name]" :id="name"
                                                                               :option="labels.methodLabels['_urformen'][name]"/>
                                                            </template>
                                                        </div>
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Umformen</p>
                                                            <template v-for="(value, name, index) in form.methods['umformen']">
                                                                <form-checkbox v-if="name !== 'umformen_andere_c' && name !== 'umformen_andere' " :key="index"
                                                                               v-model:checked="form.methods['umformen'][name]" :id="name"
                                                                               :option="labels.methodLabels['_umformen'][name]"/>
                                                            </template>
                                                        </div>
                                                        <div class="abilities--group abilities--group-2">
                                                            <p class="subtitle-1">Beschichten</p>
                                                            <template v-for="(value, name, index) in form.methods['beschichten']">
                                                                <form-checkbox v-if="name !== 'beschichten_andere_c' && name !== 'beschichten_andere' "
                                                                               :key="index" v-model:checked="form.methods['beschichten'][name]" :id="name"
                                                                               :option="labels.methodLabels['_beschichten'][name]"/>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="abilities--group abilities--group-4">
                                                            <p class="subtitle-1">Werkstoffe</p>
                                                            <form-checkbox
                                                                v-for="(value, name, index) in form.materials"
                                                                :key="index"
                                                                v-model:checked="form.materials[name]" :id="name"
                                                                :option="labels.materialLabels['_' + name]">
                                                            </form-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row row--sticky" v-sticky>
                                    <div class="col">
                                        <form-actions>
                                            <form-button type="submit" color="secondary"
                                                         icon="button-arrow-right-circle"
                                                         class="btn--block" :disabled="form.processing || disabledTab" :class="{'btn--processing': form.processing}">Speichern
                                            </form-button>
                                        </form-actions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormButton from '@partfactory/Shared/Form/FormButton';
import {useForm} from '@inertiajs/vue3';
import FormActions from '@partfactory/Shared/Form/FormActions';
import SketchPreview from '@partfactory/Shared/Elements/SketchPreview';

export default {
    name: 'Classification',
    components: {
        SketchPreview,
        FormActions,
        FormButton,
        FormCheckbox,
        CardContent, CardOverline, CardHeader, Card, AskForQuoteHeader, AppAdminLayout
    },
    props: {
        'askForQuote': Object,
        'abilities': Object,
    },
    data() {
        const form = useForm({
            methods: {},
            materials: {},
        });
        const labels = {
            methodLabels: {},
            materialLabels: {},
        };
        return {form, labels};
    },
    mounted() {

        // define methods
        let items = {};
        let labels = {};
        for (const [key] of Object.entries(this.abilities.methods)) {
            items[key] = {};
            this.abilities.methods[key].forEach((method) => {
                try {
                    items[key][method[0]] = this.askForQuote.abilities?.methods[key][method[0]] ? true : false;
                } catch (e) {
                    items[key][method[0]] = false;
                }
            });
            labels['_' + key] = {};
            this.abilities.methods[key].forEach((method) => {
                labels['_' + key][method[0]] = method[1];
            });
        }

        this.form.methods = items;
        this.labels.methodLabels = labels;

        // define materials
        items = {};
        labels = {};
        this.abilities.materials.forEach((material) => {
            try {
                items[material[0]] = this.askForQuote.abilities.materials[material[0]] ? true : false;
            } catch (e) {
                items[material[0]] = false;
            }
            labels['_' + material[0]] = material[1];
        });

        this.form.materials = items;
        this.labels.materialLabels = labels;
    },
    computed: {
        currentSketchFile() {
            return this.askForQuote.sketch_files[0];
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99) || this.askForQuote.status < 2;
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.classification.post', {'askForQuote': this.askForQuote.id}), {});
        }
    },
};
</script>
